import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { PayrollService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Payroll } from '../../models'

const log = new Logger('PayrollDetailResolver')
@Injectable({ providedIn: 'root' })
export class PayrollDetailResolver implements Resolve<Observable<Payroll>> {
  constructor(private payrollService: PayrollService, private router: Router) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let rid = route.params['pid']
    
    return this.payrollService.getDetail(rid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/payroll']))
    )
  }
}
